import { createI18n } from 'vue-i18n';
import zhLocale from './zh'; // 引入中文翻译（路径确保和文件实际位置一致）
import enLocale from './en'; // 引入英文翻译

const i18n = createI18n({
  legacy: false, // 启用Composition API模式（必须，否则$t可能不生效）
  locale: 'en', // 默认语言（英文，可根据需求改'zh'）
  globalInjection: true, // 全局注入$t方法（模板中可直接用{{ $t() }}）
  messages: {
    zh: zhLocale, // 关联中文翻译对象
    en: enLocale  // 关联英文翻译对象
  }
});

export default i18n;